/* eslint-disable */

<template>
  <div>
    <div class="vx-row">
      <!-- Left panel: classification dropdowns -->
      <div class="vx-col w-2/5">
        <vx-card class="mb-base">
          <div class="flex flex-col" style="gap: 24px">
            <div v-for="field in fields" :key="field.key" :class="getDropdownWrapperClass(field)" class="rounded-lg p-1">
              <v-select :options="classificationOptions" v-model="field.value" :placeholder="field.placeholder" />
            </div>
          </div>
        </vx-card>
      </div>

      <!-- Right panel: email message -->
      <div class="vx-col w-3/5">
        <vx-card class="mb-base">
          <template slot="no-body">
            <div class="email-header-bar p-3 text-center">
              <h3 class="font-bold text-white">Email Message</h3>
            </div>

            <table class="w-full email-table">
              <tbody>
                <tr class="email-row">
                  <td class="email-label p-3">From:</td>
                  <td class="p-3">
                    <span :class="{ 'suspicious-address': senderSelected }"> Sam Doe &lt;SamDoe@MotorCoood.com&gt; </span>
                    <div v-if="senderSelected" class="suspicious-hint mt-1">Misspelled/look-alike sender domain</div>
                  </td>
                </tr>
                <tr class="email-row">
                  <td class="email-label p-3">Reply-to:</td>
                  <td class="p-3">Sam Doe &lt;SamDoe@MotorCoood.com&gt;</td>
                </tr>
                <tr class="email-row">
                  <td class="email-label p-3">To:</td>
                  <td class="p-3">Michael Brown &lt;MichaelBrown@MotorCo.com&gt;</td>
                </tr>
                <tr class="email-row">
                  <td class="email-label p-3">Date:</td>
                  <td class="p-3">May 18, 2026 10:00 PM</td>
                </tr>
                <tr class="email-row">
                  <td class="email-label p-3">Subject:</td>
                  <td class="p-3">
                    <span :class="{ 'suspicious-address': subjectSelected, 'not-suspicious-address': subjectNotSuspicious }"
                      >Customer request</span
                    >
                    <div v-if="subjectSelected" class="suspicious-hint mt-1">Vague subject — used to avoid spam filters</div>
                    <div v-if="subjectNotSuspicious" class="not-suspicious-hint mt-1">Generic subject alone is not proof of phishing</div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="p-5" style="line-height: 1.6">
              <p class="mb-4">Hello Michael,</p>
              <div :class="{ 'suspicious-block mb-4': bodySelected, 'mb-4': !bodySelected }">
                <p>
                  I am currently out with one of our major clients and need your help. Please go to the nearest store to purchase some gift
                  cards and send over the gift card numbers with PIN as soon as possible.
                </p>
                <div v-if="bodySelected" class="suspicious-hint mt-1">Urgent gift card request with PIN — classic BEC/phishing pattern</div>
              </div>
              <div :class="{ 'suspicious-block': signatureSelected }">
                <p>Thanks</p>
                <div v-if="signatureSelected" class="suspicious-hint mt-1">Weak/missing signature; does not establish CEO identity</div>
              </div>
              <div class="flex justify-end mt-6">
                <vs-button type="border" color="primary" disabled>Send</vs-button>
              </div>
            </div>
          </template>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),

      classificationOptions: ['Suspicious', 'Not suspicious'],

      fields: [
        { key: 'sender', placeholder: 'Select for sender', answer: 'Suspicious', value: null, score: null },
        { key: 'subject', placeholder: 'Select for subject', answer: 'Not suspicious', value: null, score: null },
        { key: 'body', placeholder: 'Select for body', answer: 'Suspicious', value: null, score: null },
        { key: 'signature', placeholder: 'Select for signature', answer: 'Suspicious', value: null, score: null },
      ],
    };
  },
  computed: {
    senderSelected() {
      return this.fields.find((f) => f.key === 'sender')?.value === 'Suspicious';
    },
    subjectSelected() {
      return this.fields.find((f) => f.key === 'subject')?.value === 'Suspicious';
    },
    subjectNotSuspicious() {
      return this.fields.find((f) => f.key === 'subject')?.value === 'Not suspicious';
    },
    bodySelected() {
      return this.fields.find((f) => f.key === 'body')?.value === 'Suspicious';
    },
    signatureSelected() {
      return this.fields.find((f) => f.key === 'signature')?.value === 'Suspicious';
    },
  },
  methods: {
    markSimulation() {
      let totalScore = 0;

      this.fields.forEach((field, i) => {
        if (field.value === field.answer) {
          this.fields[i].score = true;
          totalScore++;
        } else {
          this.fields[i].score = false;
        }
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },

    getDropdownWrapperClass(field) {
      if (field.score === true) return 'border-solid border-2 border-success';
      if (field.score === false) return 'border-solid border-2 border-danger';
      return '';
    },
  },
  components: {
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.email-header-bar {
  background: #5a5fc7;
}

.email-table {
  border-collapse: collapse;
  width: 100%;
}

.email-row td {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.email-label {
  font-weight: 600;
  width: 90px;
  vertical-align: top;
  white-space: nowrap;
  opacity: 0.7;
}

.suspicious-address {
  display: inline-block;
  border: 2px solid #e74c3c;
  padding: 1px 6px;
}

.suspicious-block {
  display: block;
  border: 2px solid #e74c3c;
  padding: 6px 8px;
}

.suspicious-hint {
  color: #e74c3c;
  font-size: 13px;
}

.not-suspicious-address {
  display: inline-block;
  border: 2px solid #27ae60;
  padding: 1px 6px;
}

.not-suspicious-hint {
  color: #27ae60;
  font-size: 13px;
}
</style>
